import scrollIt from '../vendor/scrollIt';
import { getVideoPlayer } from './videos';
import globals from './globals';

let scrollTop =
  window.scrollY === undefined ? window.pageYOffset : window.scrollY;
let windowHeight = window.innerHeight;
let headerHeight = 0;
let bottomHeight = 0;
let windowWidth = document.body.clientWidth;

let supportsPassive = false;
try {
  const opts = Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get() {
      supportsPassive = true;
    },
  });
  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
  // eslint-disable-next-line no-empty
} catch (e) {}

function parallaxHeadings() {
  const prallaxBackgrounds = document.querySelectorAll(
    '.c-headline__background',
  );
  const elementsData = [];

  if (prallaxBackgrounds.length < 1) {
    return;
  }

  [].forEach.call(prallaxBackgrounds, background => {
    elementsData.push({
      bg: background,
      container: background.parentNode,
      height: 0,
      top: 0,
      bottom: 0,
      distance: 0,
    });
  });

  function calculatePositions() {
    for (let i = 0; i < elementsData.length; i += 1) {
      const elementData = elementsData[i];
      const containerSize = elementData.container.getBoundingClientRect();
      const bgSize = elementData.bg.getBoundingClientRect();
      elementData.top = scrollTop + containerSize.top;
      elementData.height = containerSize.height;
      elementData.bottom = elementData.top + elementData.height;
      elementData.distance =
        (bgSize.height / elementData.height - 1) * elementData.height;
    }
  }

  function adjustPositions() {
    const bottomPos = scrollTop + windowHeight;
    for (let i = 0; i < elementsData.length; i += 1) {
      const elementData = elementsData[i];

      if (bottomPos > elementData.top && scrollTop < elementData.bottom) {
        const pos =
          -elementData.distance *
          (1 -
            (bottomPos - elementData.top) /
              (windowHeight + elementData.height));

        elementData.bg.style.transform = `translateY(${pos}px)`;
      }
    }
  }

  calculatePositions();
  adjustPositions();
  window.addEventListener('resize', calculatePositions);
  window.addEventListener('load', () => {
    calculatePositions();
    adjustPositions();
  });
  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(adjustPositions);
  });
}

function fixedMenu() {
  const header = document.querySelector('.c-header');
  const adminBar = document.querySelector('#wpadminbar');

  if (header === null) {
    return;
  }

  const sliderHero = document.querySelector('.c-slider--hero');
  const heroBottom = header.querySelector('.c-header__bottom');
  const heroBottomBackground = header.querySelector(
    '.c-header__bottom-background',
  );
  const heroTopBackground = header.querySelector('.c-header__inner-background');
  const containerToSpy = sliderHero !== null ? sliderHero : header;
  const containerDefaultClass = containerToSpy.getAttribute('class');
  let containerHeight = 0;
  let hideTimout = null;
  let oldScrollTop = scrollTop;
  let fixedBottom = false;

  function updateContainerHeight() {
    windowWidth = document.body.clientWidth;

    const containerClass = containerToSpy.getAttribute('class');

    if (containerToSpy === header) {
      header.setAttribute('class', containerDefaultClass);
    }

    // eslint-disable-next-line no-multi-assign
    headerHeight = containerHeight = containerToSpy.offsetHeight;

    if (heroBottom !== null) {
      bottomHeight = heroBottom.offsetHeight;
    }

    if (windowWidth > 767 && header.style.height !== '') {
      header.style.height = '';
    }

    if (containerToSpy === header) {
      header.setAttribute('class', containerClass);
    }
  }

  function checkMenuStatus() {
    const scrollingDown = scrollTop > oldScrollTop;
    let scrollBorder = containerHeight;

    if (adminBar !== null && windowWidth < 768) {
      scrollBorder += adminBar.offsetHeight;
    }

    if (scrollTop > containerHeight && !header.classList.contains('fixed')) {
      clearTimeout(hideTimout);
      hideTimout = null;
      if (windowWidth < 768) {
        header.style.height = `${containerHeight}px`;

        if (heroTopBackground !== null) {
          heroTopBackground.style.height = `${containerHeight}px`;
        }
      }
      header.classList.add('no-animation');
      header.classList.add('fixed');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          header.classList.remove('no-animation');
        });
      });
    } else if (
      scrollTop <= scrollBorder &&
      header.classList.contains('fixed') &&
      hideTimout === null
    ) {
      header.classList.add('hidden');

      hideTimout = setTimeout(() => {
        if (scrollTop <= scrollBorder) {
          header.classList.remove('fixed');
          header.classList.remove('hidden');

          if (windowWidth < 768) {
            if (heroTopBackground !== null) {
              heroTopBackground.style.height = '';
            }
          }
        }
        hideTimout = null;
      }, 400);
    }

    if (scrollingDown && !header.classList.contains('hidden')) {
      header.classList.add('hidden');
    } else if (
      !scrollingDown &&
      header.classList.contains('hidden') &&
      hideTimout === null
    ) {
      header.classList.remove('hidden');
    }

    if (heroBottom !== null && windowWidth > 767) {
      let topBorder = containerHeight - bottomHeight;
      let bottomBorder = containerHeight;

      if (adminBar !== null && windowWidth < 768) {
        topBorder += adminBar.offsetHeight;
        bottomBorder += adminBar.offsetHeight;
      }

      if (
        !fixedBottom &&
        ((scrollingDown && scrollTop > topBorder) ||
          (!scrollingDown && scrollTop > containerHeight))
      ) {
        header.classList.add('fixed-bottom');
        fixedBottom = true;
      } else if (
        fixedBottom &&
        ((!scrollingDown && oldScrollTop < bottomBorder) ||
          scrollTop < topBorder)
      ) {
        header.classList.remove('fixed-bottom');
        header.classList.add('no-animation-bottom');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            header.classList.remove('no-animation-bottom');
          });
        });
        fixedBottom = false;
        if (heroBottomBackground !== null) {
          heroBottomBackground.style.height = '';
        }
      }
    }

    if (windowWidth < 768 && header.classList.contains('fixed-bottom')) {
      header.classList.remove('fixed-bottom');
    }

    oldScrollTop = scrollTop;
  }

  updateContainerHeight();
  checkMenuStatus();

  window.addEventListener('resize', updateContainerHeight);
  window.addEventListener('load', updateContainerHeight);
  window.addEventListener('scroll', checkMenuStatus);
}

function videoAutoplay() {
  const videos = document.querySelectorAll('.c-video');

  if (videos.length < 1) {
    return;
  }

  const videosData = [];
  let checkTimeout = null;

  [].forEach.call(videos, video => {
    const isSlide =
      video.classList.contains('c-slider__slide') ||
      video.parentNode.parentNode.classList.contains('c-slider__slide');
    const data = {
      video,
      top: 0,
      bottom: 0,
      player: getVideoPlayer(video),
      isSlide,
    };

    if (isSlide) {
      const slide = video.classList.contains('c-slider__slide')
        ? video
        : video.parentNode.parentNode.className;
      const slider = slide.parentNode.parentNode;
      const isSliderFullscreen = slider.classList.contains(
        'c-slider--fullscreen',
      );

      data.slide = slide;
      data.slider = slider;
      data.isSliderFullscreen = isSliderFullscreen;
    }

    videosData.push(data);
  });

  function canBePlayed(videoData) {
    if (videoData.isSlide) {
      const isFullscreen = globals.html.classList.contains(
        'is-slider-fullscreen',
      );

      if (
        (!isFullscreen && videoData.isSliderFullscreen) ||
        (isFullscreen && !videoData.slider.classList.contains('active'))
      ) {
        return false;
      }

      if (isFullscreen && !videoData.isSliderFullscreen) {
        return false;
      }

      if (/(left|right|faded-)/.test(videoData.slide.className)) {
        return false;
      }
    }

    return !videoData.video.hasAttribute('data-paused');
  }

  function collectVideoData() {
    [].forEach.call(videosData, videoData => {
      const rect = videoData.video.getBoundingClientRect();
      // eslint-disable-next-line no-param-reassign
      videoData.top = rect.top + scrollTop;
      // eslint-disable-next-line no-param-reassign
      videoData.bottom = videoData.top + rect.height;
      // eslint-disable-next-line no-param-reassign
      videoData.middle = videoData.top + rect.height * 0.5;
    });
  }

  function autoPlayVideo() {
    let distance = 0;
    let closestVideoData = null;
    const baseLine = scrollTop + windowHeight * 0.5;

    for (let i = 0; i < videosData.length; i += 1) {
      const videoData = videosData[i];
      const videoDistance = Math.abs(baseLine - videoData.middle);
      if (
        (closestVideoData === null || videoDistance < distance) &&
        (videoData.bottom > scrollTop &&
          videoData.top < scrollTop + windowHeight) &&
        canBePlayed(videoData)
      ) {
        distance = videoDistance;
        closestVideoData = videoData;
      } else {
        videoData.player.pause();
      }
    }

    if (closestVideoData !== null && canBePlayed(closestVideoData)) {
      closestVideoData.player.play();
    }
  }

  collectVideoData();
  autoPlayVideo();

  window.addEventListener('resize', () => {
    collectVideoData();
  });

  window.addEventListener('scroll', () => {
    clearTimeout(checkTimeout);
    checkTimeout = setTimeout(autoPlayVideo, 500);
  });
}

function autoscroll() {
  const header = document.querySelector(
    '.c-header:not(.c-header--transparent)',
  );

  if (header === null) {
    return;
  }

  let isScrolling = false;

  const wheelHandler = event => {
    if (
      event.deltaY > 0 &&
      !isScrolling &&
      scrollTop < (headerHeight - bottomHeight) * 0.6
    ) {
      isScrolling = true;
      scrollIt(headerHeight - bottomHeight, 500, 'easeOutQuad', () => {
        isScrolling = false;
      });
    }

    if (isScrolling) {
      event.preventDefault();
    }
  };

  const addWheelHandler = () => {
    window.addEventListener(
      'wheel',
      wheelHandler,
      supportsPassive ? { passive: false } : undefined,
    );
  };

  const removeWheelHandler = () => {
    window.removeEventListener(
      'wheel',
      wheelHandler,
      supportsPassive ? { passive: false } : undefined,
    );

    window.removeEventListener('touchstart', removeWheelHandler);
  };

  window.addEventListener('touchstart', removeWheelHandler);

  addWheelHandler();
}

export default () => {
  window.addEventListener('scroll', () => {
    scrollTop =
      window.scrollY === undefined ? window.pageYOffset : window.scrollY;
  });

  window.addEventListener('resize', () => {
    windowHeight = window.innerHeight;
  });

  parallaxHeadings();
  fixedMenu();
  videoAutoplay();
  autoscroll();
};



// WEBPACK FOOTER //
// ./src/scripts/modules/scroll-spy.js